<template>
  <div style="height: 150px" class="flex gap-4">
    <q-card
      class="flex-1 h-full rounded-lg overflow-hidden shadow-sm"
      v-for="(n, i) in ui"
      :key="i"
    >
      <q-card-section horizontal class="h-full">
        <q-card-section class="flex flex-center px-8">
          <q-icon :name="n.icon" :color="n.color" style="font-size: 50px">
            <q-tooltip content-class="bg-black">{{ n.title }} </q-tooltip>
          </q-icon>
        </q-card-section>
        <q-separator inset vertical class="mr-4" />
        <q-card-section class="flex-1 flex flex-col pl-0 gap-1">
          <div>
            <span class="font-bold">{{ `${data[i].length} ` }}</span>
            {{ `${n.caption}` }}
          </div>
          <div
            class="flex-1 overflow-auto flex-no-wrap rounded-sm border-1 border-solid border-grey-light"
            style="background: rgba(0, 0, 0, 0.056)"
          >
            <q-scroll-area class="fit">
              <div class="fit flex flex-col gap-1 p-1">
                <div
                  class="bg-white rounded-sm flex flex-col overflow-hidden relative p-2"
                  v-for="item in []"
                >
                  <div
                    style="width: 2px"
                    class="h-full bg-red absolute left-0 top-0"
                  />

                  <div>
                    <span
                      class="h-full text-sm flex items-center ml-4 font-bold"
                    >
                      {{ 'ABC - ABC1234' }}
                    </span>
                  </div>
                  <div style="height: 1px" class="w-full bg-grey"></div>
                  <div class="px-2 flex items-center mt-1">
                    <span class="flex flex-no-wrap gap-2 text-xs font-bold">
                      <q-badge color="white" style="border-radius: 50px">
                        <q-icon
                          name="calendar_today"
                          color="purple"
                          size="8px"
                        />
                      </q-badge>
                      10/04/2024
                    </span>
                    <span class="h-full text-sm flex items-center ml-1">
                      {{ '- 30 days more' }}
                    </span>
                  </div>
                </div>
              </div>
            </q-scroll-area>
          </div>
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const ui = [
  {
    title: 'Reminders',
    icon: 'notifications',
    color: 'purple',
    caption: 'items requiring attention',
  },
  {
    title: 'Upcoming',
    icon: 'calendar_month',
    color: 'blue',
    caption: 'upcoming maintenance',
  },
  {
    title: 'Due Maintenance',
    icon: 'warning',
    color: 'danger',
    caption: 'items due maintenance',
  },
];

// const data = ref([[{ days: 30 }], [{}, {}, {}, {}, {}], []]);
const data = ref([[], [], []]);
</script>

<style lang="scss" scoped></style>
